"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cache = void 0;
const cache = {
    files: {},
    add: function (key, file) {
        this.files[key] = file;
    },
    get: function (key) {
        return this.files[key];
    },
    remove: function (key) {
        delete this.files[key];
    },
    clear: function () {
        this.files = {};
    },
};
exports.cache = cache;
